import '../../globals';

/**
 * Article page: make price and button cols same height
 */
(function(PageLoadedQueue) {
    const setArticlePageHeights = () => {
        $('.article-header .equalize-height').equalHeights('reset').equalHeights();
    }

    const resetArticlePageHeights = () => {
        $('.article-header .equalize-height').equalHeights('reset');
    }

    document.addEventListener('plandent.articles.setHeights', setArticlePageHeights, {passive: true});
    document.addEventListener('plandent.articles.resetHeights', resetArticlePageHeights, {passive: true});
})(window.PageLoadedQueue);
